import { Component, inject } from '@angular/core';
import { SettingsService } from '../../shared/settings/settings.service';
import { ViewModelProperty, SettingsFormComponent } from '@lfw/roesberg';
import { InfoService } from '../../shared/services/info.service';
import { LfwRouterService } from '../../route/lfw-router.service';

@Component({
  selector: 'lfw-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.css'],
  imports: [SettingsFormComponent]
})
export class SettingsPageComponent {
  settings: Array<Array<ViewModelProperty>>;

  private settingsService = inject(SettingsService);
  private routerService = inject(LfwRouterService);
  private infoService = inject(InfoService);

  constructor() {
    this.settings = this.settingsService.settings.visibleSettings;
    this.infoService.clearStatus();
  }

  goToChangePassword() {
    this.routerService.navigateToPasswordChange();
  }
}
